import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  ref: "asap",
  class: "m-datePicker__option",
  for: "asap"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("input", {
  id: "asap",
  type: "radio",
  class: "m-datePicker__optionInput",
  name: "date",
  value: "asap",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["for"]
const _hoisted_5 = ["id", "checked", "value"]
const _hoisted_6 = {
  key: 0,
  class: "m-datePicker__optionContent"
}
const _hoisted_7 = { class: "m-datePicker__optionWeekday" }
const _hoisted_8 = { class: "a-heading1 m-datePicker__optionDay" }
const _hoisted_9 = { class: "m-datePicker__optionMonth" }
const _hoisted_10 = {
  key: 1,
  class: "m-datePicker__optionContent"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_icon = _resolveComponent("a-icon")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "datePicker",
    class: _normalizeClass(["m-datePicker", {
            'm-datePicker--horizontal': $props.direction === 'horizontal',
            'm-datePicker--vertical': $props.direction !== 'horizontal',
            isNotTouch: !$data.hasTouch,
            isOverflownLeft: $data.isOverflownLeft && $data.hasTouch,
            isOverflownRight: $data.isOverflownRight && $data.hasTouch,
        }])
  }, [
    ($props.direction === 'horizontal' && !$data.showingDatesStart)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "m-datePicker__control m-datePicker__control--left",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.browseShowingDates('previous')))
        }, [
          _createVNode(_component_a_icon, { name: "chevron_left" })
        ]))
      : _createCommentVNode("v-if", true),
    ($props.direction === 'horizontal' && !$data.showingDatesEnd)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "m-datePicker__control m-datePicker__control--right",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.browseShowingDates('next')))
        }, [
          _createVNode(_component_a_icon, { name: "chevron_right" })
        ]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", {
      ref: "dates",
      role: "group",
      "aria-label": "Vælg dato og tidsrum",
      class: _normalizeClass({
                isScrolled: !$data.showingDatesStart,
                'm-datePicker__options--horizontal': $props.direction === 'horizontal',
            }),
      onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.setOption($event)))
    }, [
      ($props.direction === 'horizontal')
        ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
            _hoisted_2,
            _createElementVNode("div", {
              id: "asapContent",
              class: "m-datePicker__optionContent",
              textContent: _toDisplayString($props.asapText)
            }, null, 8 /* PROPS */, _hoisted_3)
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.dates, (date, index) => {
        return (_openBlock(), _createElementBlock("label", {
          key: index,
          ref_for: true,
          ref: "dateItems",
          class: _normalizeClass(["m-datePicker__option", {
                    hasOpenHouse: date.isOpenHouse,
                    isNotTouch: !$data.hasTouch,
                    disabled: !date.required && $props.direction !== 'horizontal',
                }]),
          for: `date${index}`
        }, [
          _createElementVNode("input", {
            id: `date${index}`,
            type: "radio",
            class: "m-datePicker__optionInput",
            name: "date",
            checked: 
                        date.date === $props.initialDate ||
                            (date.required && date.date === $options.shortInitialDate)
                    ,
            value: 
                        $props.direction === 'horizontal'
                            ? date.date
                            : index.toString()
                    ,
            autocomplete: "off"
          }, null, 8 /* PROPS */, _hoisted_5),
          ($props.direction === 'horizontal')
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(date.dayName), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_8, _toDisplayString(date.day), 1 /* TEXT */),
                _createElementVNode("span", _hoisted_9, _toDisplayString(date.monthName), 1 /* TEXT */)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", {
                  innerHTML: 
                            `${date.dayName} ${date.date} ${date.monthName} kl. ${date.fromTime} — ${date.toTime}`
                        
                }, null, 8 /* PROPS */, _hoisted_11),
                (date.required)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: "m-datePicker__optionContentSmall",
                      textContent: _toDisplayString($props.smallTextSignup)
                    }, null, 8 /* PROPS */, _hoisted_12))
                  : (_openBlock(), _createElementBlock("small", {
                      key: 1,
                      class: "m-datePicker__optionContentSmall",
                      textContent: _toDisplayString($props.smallTextNoSignup)
                    }, null, 8 /* PROPS */, _hoisted_13))
              ]))
        ], 10 /* CLASS, PROPS */, _hoisted_4))
      }), 128 /* KEYED_FRAGMENT */))
    ], 34 /* CLASS, NEED_HYDRATION */)
  ], 2 /* CLASS */))
}